import { Link, Stack } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLines } from 'core/elements';
import { CostSourceHelper, PricingHelper } from 'pricing/helpers';
import { ICostSourceData } from 'pricing/types';
import { IQuotePartCostData } from 'quotes/types';
import { Level } from 'theme/enums';

interface IProps {
  costSource: IQuotePartCostData;
}

export const CostSource = ({ costSource }: IProps) => {
  const costSourceLabel = CostSourceHelper.getTypeLabel(costSource);

  const costSourceDiscountTypeLabel = CostSourceHelper.getDiscountTypeLabel(costSource);

  const extras = [];
  const discountValue = costSource?.costSourceDiscountValue;
  if (discountValue > 0) {
    extras.push(PricingHelper.discount(discountValue));
  }

  const pricingProfileName = CostSourceHelper.getPricingProfileName(costSource as ICostSourceData);
  if (pricingProfileName) {
    const pricingProfileUrl = CostSourceHelper.getPricingProfileUrl(costSource as ICostSourceData);

    extras.push(
      pricingProfileUrl ? (
        <Link level={Level.BODY_XS} component={RouterLink} to={pricingProfileUrl}>
          {pricingProfileName}
        </Link>
      ) : (
        pricingProfileName
      )
    );
  }

  return (
    <Stack>
      <TextLines
        texts={[
          costSourceLabel.long || DEFAULT_PLACEHOLDER,
          costSourceDiscountTypeLabel.long,
        ].filter((value) => !!value)}
        bold
        textEllipsis
      />

      <TextLines texts={[...extras]} isSubText textEllipsis />
    </Stack>
  );
};
